<h2 mat-dialog-title></h2>
<mat-dialog-actions class="float-right">
    <button mat-button (click)="onCloseModal()">
        <mat-icon aria-hidden="false" aria-label="Example home icon">close</mat-icon>
    </button>
</mat-dialog-actions>
<mat-dialog-content class="modal">
    <ng-container>
        <iframe #iPayment class="iframe-pago" seamless width="600" [height]="iframeHeigth"
            [src]="urlPayment"> </iframe>
    </ng-container>
</mat-dialog-content>
